
export const Add_CATEGORY = 'Add_CATEGORY';
export const GET_ALL_CATEGORIES = 'GET_ALL_CATEGORIES';

export const ADD_QUESTION = 'ADD_QUESTION';

export const GET_ALL_QUESTIONS = 'GET_ALL_QUESTIONS';
export const SEND_MAIL = 'SEND_MAIL'

